import { Component } from "react";
import MaintenanceOverlay from "./MaintenanceOverlay";
import { siteConfig } from "../lib/siteConfig";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep a useful console trail for us while customers see the maintenance message.
    console.error(`${siteConfig.name} frontend error`, error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const isAdmin = window.location.pathname.startsWith("/admin");

    if (isAdmin) {
      return (
        <div className="grid min-h-screen place-items-center bg-[#030705] p-6 text-white">
          <div className="max-w-md rounded-2xl border border-white/10 bg-white/[0.04] p-6 text-center">
            <h1 className="font-display text-2xl font-black">Admin panel needs a refresh</h1>
            <p className="mt-2 text-sm text-white/60">Something failed while loading this view.</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-5 rounded-full bg-[#D4AF37] px-5 py-3 font-bold text-black"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return <MaintenanceOverlay fatal onRetry={() => window.location.reload()} />;
  }
}
